import { ajax } from "@tm/utils"
import { getAuthenticationToken } from "../getAuthenticationToken"
import { GetStorageUrisResponse } from "./models"

export async function getStorageUris(baseUrl: string, transferId: string) {
    const token = await getAuthenticationToken()
    const url = `${baseUrl}/api/v2/files/getstorageuris/${transferId}`
    return ajax<GetStorageUrisResponse>({ url, method: "GET", headers: { Authorization: token } })
}
